import React from 'react'

const Toolbar = ({ children }) => (
  <div className="pb-2 pt-2 order-header-container row">
    {children}
  </div>
)

export default Toolbar
